import { Container, HeadingContainer, Heading, Actions } from './styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useIsTruncated } from '../../../hooks/useIsTruncated.js';
import { GridContainer } from '../../foundation/Grid/styled.js';
import { Tooltip } from '../../dataDisplay/Tooltip/Tooltip/index.js';
import { H1 } from '../../foundation/Typography/styled.js';

function PageHeader(props) {
  var actions = props.actions,
    breadcrumbs = props.breadcrumbs,
    heading = props.heading,
    chip = props.chip,
    tabs = props.tabs;
  var headingRef = useIsTruncated();
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsxs(GridContainer, {
      children: [breadcrumbs, /*#__PURE__*/jsxs(HeadingContainer, {
        children: [/*#__PURE__*/jsxs(Heading, {
          children: [/*#__PURE__*/jsx(Tooltip, {
            disabled: !headingRef.isTruncated,
            title: heading,
            children: /*#__PURE__*/jsx(H1, {
              $truncate: true,
              ref: headingRef.ref,
              children: heading
            })
          }), chip]
        }), actions && /*#__PURE__*/jsx(Actions, {
          children: actions
        })]
      }), tabs]
    })
  });
}

export { PageHeader };
